import React from "react";
import "../../../styles/utils/modal/InfoModal.scss";
import useAppTranslation from "../../../hooks/useAppTranslation";

const InfoModal = ({ onConfirm, title, tips }) => {
  const { t } = useAppTranslation("pages/making");

  return (
    <>
      <section className="alert-modal">
        <figure className="close-modal-btn" onClick={onConfirm}>
          <img src={"/images/utils/close.png"} alt="" />
        </figure>
        <div className="wizard">
          <img
            src={React.useMemo(() => {
              const wizards = [
                "/images/utils/modal/wizard-nikki.webp",
                "/images/utils/modal/wizard-arial.webp",
              ];
              return wizards[Math.floor(Math.random() * wizards.length)];
            }, [])}
            alt="wizard"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="text-container">
          <p className="title">{title}</p>
          <p className="tips">{tips}</p>
        </div>
        <div className="btn" onClick={onConfirm}>
          {t("actions.confirm")}
        </div>
      </section>
    </>
  );
};

export default InfoModal;
